// src/components/admin/AdminPolls.jsx
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { apiFetch } from '../utils/auth';
import { API_URL } from '../config';
import s from './AdminPanel.module.css';
import ns from './News.module.css'; // стили списка как у ДР/новостей
import actionsIcon from '../icons/admin_panel_actions.svg';
import { ReactComponent as FabBubble } from '../icons/circle.svg';
import { ReactComponent as AddIconPlus } from '../icons/add_icon_plus.svg';
import { ReactComponent as CloseIcon } from '../icons/close_button.svg';
import { ReactComponent as UploadChatPictureIcon } from '../icons/upload_chat_picture.svg';
import { ReactComponent as CopyMessageIcon } from '../icons/copy_message.svg';
import { Input, Textarea, Select, ActionsMenu } from './UI';
import actionsMenuStyles from './UI/ActionsMenu.module.css';

/** ======================== СПИСОК ГОЛОСОВАНИЙ ======================== */
export default function AdminPolls() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [menuOpenFor, setMenuOpenFor] = useState(null);  // id

  const [createOpen, setCreateOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);    // Poll
  const [detail, setDetail] = useState(null);    // { poll, scores: [], comments: [] }

  // закрытие меню по клику вне / Esc
  useEffect(() => {
    const onDocClick = (e) => {
      if (!menuOpenFor) return;
      if (!e.target.closest?.(`.${actionsMenuStyles.wrap}`)) {
        setMenuOpenFor(null);
      }
    };
    const onEsc = (e) => { if (e.key === 'Escape') setMenuOpenFor(null); };
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onEsc);
    };
  }, [menuOpenFor]);

  const load = async () => {
    setLoading(true);
    try {
      const r = await apiFetch(`${API_URL}/admin/polls`);
      const js = r.ok ? await r.json() : [];
      const arr = Array.isArray(js) ? js : [];
      // сортируем: активные сверху, затем по дате начала
      arr.sort((a, b) => {
        const an = a.is_active ? 0 : 1;
        const bn = b.is_active ? 0 : 1;
        if (an !== bn) return an - bn;
        return String(b.start_at || '').localeCompare(String(a.start_at || ''));
      });
      setItems(arr);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const StatsIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M8 13V17M16 11V17M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const EmployeesTypeIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const TeamsTypeIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const OptionsTypeIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7.5 10.5H7.51M12 10.5H12.01M16.5 10.5H16.51M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18ZM8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5C7 10.2239 7.22386 10 7.5 10C7.77614 10 8 10.2239 8 10.5ZM12.5 10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.7239 10 12 10C12.2761 10 12.5 10.2239 12.5 10.5ZM17 10.5C17 10.7761 16.7761 11 16.5 11C16.2239 11 16 10.7761 16 10.5C16 10.2239 16.2239 10 16.5 10C16.7761 10 17 10.2239 17 10.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const openDetail = async (poll) => {
    const r = await apiFetch(`${API_URL}/admin/polls/${poll.id}/results`);
    const data = r.ok ? await r.json() : { scores: [], comments: [] };
    setDetail({ poll, scores: data.scores || [], comments: data.comments || [] });
  };

  const remove = async (id) => {
    if (!window.confirm('Удалить голосование? Все голоса будут удалены.')) return;
    const r = await apiFetch(`${API_URL}/admin/polls/${id}`, { method: 'DELETE' });
    if (!r.ok) { alert('Не удалось удалить'); return; }
    await load();
  };

  const toggleActive = async (poll) => {
    const next = !poll.is_active;

    const ok = window.confirm(
      next
        ? 'Открыть голосование? Оно появится у сотрудников на главной странице.'
        : 'Закрыть голосование? Оно исчезнет у сотрудников на главной странице.'
    );
    if (!ok) return;

    const r = await apiFetch(`${API_URL}/admin/polls/${poll.id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ is_active: next }),
    });

    if (!r.ok) {
      alert('Не удалось изменить статус голосования');
      return;
    }

    await load();
  };

  // лок скролла при открытых модалках
  useEffect(() => {
    const any = !!createOpen || !!editItem || !!detail;
    if (!any) return;
    const y = window.scrollY;
    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${y}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    return () => {
      const top = body.style.top;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      window.scrollTo(0, top ? -parseInt(top, 10) : 0);
    };
  }, [createOpen, editItem, detail]);

  return (
    <div className={s.section}>
      {loading && <p>Загрузка…</p>}

      {/* Список — карточки как у ДР: превью слева, контент справа, дата справа в мета */}
      <ul className={ns.list}>
        {items.map(p => {
          const dateStr = p.start_at
            ? new Date(p.start_at).toLocaleDateString()
            : (p.created_at ? new Date(p.created_at).toLocaleDateString() : '');
          const TypeIcon = p.type === 'employees'
            ? EmployeesTypeIcon
            : p.type === 'teams'
              ? TeamsTypeIcon
              : OptionsTypeIcon;
          const typeLabel = p.type === 'employees'
            ? 'Сотрудники'
            : p.type === 'teams'
              ? 'Команды'
              : 'Варианты';
          return (
            <li
              key={p.id}
              className={`${ns.row} ${s.pollRow}`}
              onClick={() => setEditItem(p)}
              role="button"
              title={p.title || 'Голосование'}
            >
              <div className={s.pollTypeIconWrap} aria-hidden="true">
                <TypeIcon className={s.pollTypeIcon} />
              </div>

              <div className={`${ns.content} ${s.pollContent}`}>
                <div className={s.pollTitleRow}>
                  <span className={`${ns.title} ${s.pollTitleText}`} style={{ margin: 0, lineHeight: '18px' }}>
                    {p.title || 'Без названия'}
                  </span>
                  <div className={s.pollPills}>
                    <span className={`${s.pollPill} ${p.is_active ? s.pollPillActive : s.pollPillInactive}`}>
                      {p.is_active ? 'Активно' : 'Не активно'}
                    </span>
                    <span className={s.pollPill}>
                      {p.is_multiple ? 'Несколько вариантов' : 'Один вариант'}
                    </span>
                  </div>
                </div>

                {(p.description || dateStr || typeLabel) && (
                  <div className={s.pollDescription}>
                    {p.description ? String(p.description).trim() : `${typeLabel}${dateStr ? ` · ${dateStr}` : ''}`}
                  </div>
                )}
              </div>

              <div className={s.actions} onClick={(e) => e.stopPropagation()}>
                <button
                  type="button"
                  className={s.pollStatsBtn}
                  aria-label="Статистика"
                  title="Статистика"
                  onClick={() => {
                    setMenuOpenFor(null);
                    openDetail(p);
                  }}
                >
                  <StatsIcon />
                </button>
                <ActionsMenu
                  open={menuOpenFor === p.id}
                  onToggle={() => setMenuOpenFor((cur) => (cur === p.id ? null : p.id))}
                  title="Действия"
                  align="left"
                  trigger={<img src={actionsIcon} alt="" className={s.iconDots} />}
                  wrapClassName={actionsMenuStyles.wrap}
                  buttonClassName={`${s.iconBtn} ${s.pollMenuBtn}`}
                  items={[
                    {
                      key: 'toggle',
                      label: p.is_active ? 'Закрыть голосование' : 'Открыть голосование',
                      onClick: () => { setMenuOpenFor(null); toggleActive(p); },
                    },
                    {
                      key: 'edit',
                      label: 'Редактировать',
                      onClick: () => { setMenuOpenFor(null); setEditItem(p); },
                    },
                    {
                      key: 'stats',
                      label: 'Статистика',
                      onClick: () => { setMenuOpenFor(null); openDetail(p); },
                    },
                    {
                      key: 'delete',
                      label: 'Удалить',
                      danger: true,
                      onClick: () => { setMenuOpenFor(null); remove(p.id); },
                    },
                  ]}
                />
              </div>
            </li>
          );
        })}
      </ul>

      {/* FAB — создать */}
      <button
        type="button"
        className={s.fab}
        aria-label="Создать голосование"
        title="Создать голосование"
        onClick={() => setCreateOpen(true)}
      >
        <span className={s.fabSvgWrap}>
          <FabBubble className={s.fabBubble} />
          <div className={s.fabInner}><AddIconPlus className={s.fabIcon} /></div>
        </span>
      </button>

      {createOpen && (
        <PollModal
          title="Новое голосование"
          onCancel={() => setCreateOpen(false)}
          onSubmit={async (payload) => {
            const r = await apiFetch(`${API_URL}/admin/polls`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
            });
            if (!r.ok) { alert('Не удалось создать'); return; }
            setCreateOpen(false);
            await load();
          }}
        />
      )}

      {editItem && (
        <PollModal
          title="Редактировать голосование"
          initial={editItem}
          onCancel={() => setEditItem(null)}
          onSubmit={async (patch) => {
            const r = await apiFetch(`${API_URL}/admin/polls/${editItem.id}`, {
              method: 'PATCH',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(patch),
            });
            if (!r.ok) { alert('Не удалось сохранить'); return; }
            setEditItem(null);
            await load();
          }}
        />
      )}

      {detail && (
        <PollDetailModal
          data={detail}
          onClose={() => setDetail(null)}
          onReload={async () => {
            const r = await apiFetch(`${API_URL}/admin/polls/${detail.poll.id}/results`);
            if (r.ok) {
              const d = await r.json();
              setDetail({ poll: detail.poll, scores: d.scores || [], comments: d.comments || [] });
            }
          }}
        />
      )}
    </div>
  );
}

/** ======================== МОДАЛКА СОЗДАНИЯ/РЕДАКТА ======================== */
function PollModal({ title, initial, onCancel, onSubmit }) {
  const [titleVal, setTitleVal] = useState(initial?.title || '');
  const [desc, setDesc] = useState(initial?.description || '');

  // --- Картинка ---
  const fileRef = useRef(null);
  const [imageFile, setImageFile] = useState(null);               // новый файл перед сохранением
  const [imagePreview, setImagePreview] = useState(null);         // objectURL для нового файла
  const [isDragOverImage, setIsDragOverImage] = useState(false);
  const API_BASE = (API_URL || '').replace(/\/api\/v\d+\/?$/, ''); // резолв относительных путей
  const initialPreview = useMemo(
    () => initial?.image_path ? `${API_BASE}${initial.image_path}` : null,
    [initial, API_BASE]
  );
  const [keepInitial, setKeepInitial] = useState(!!initial?.image_path); // показывать ли картинку из БД

  const [allowMultiple, setAllowMultiple] = useState(!!initial?.is_multiple || !!initial?.allow_multiple);
  const [startsAt] = useState(
    initial?.start_at ? toLocalDatetime(initial.start_at) :
      (initial?.starts_at ? toLocalDatetime(initial.starts_at) : '')
  );
  const [endsAt] = useState(
    initial?.end_at ? toLocalDatetime(initial.end_at) :
      (initial?.ends_at ? toLocalDatetime(initial.ends_at) : '')
  );


  // Определяем тип голосования: 'employees' | 'options' | 'teams'
  const [pollType, setPollType] = useState(
    initial?.type ? initial.type :
      (initial?.options?.length
        ? (initial.options.filter(o => !!o.employee_id).length > initial.options.length / 2 ? 'employees' : 'options')
        : 'employees')
  );

  // Локальный список опций для режима 'options'
  const [options, setOptions] = useState(
    // поддержка team_id
    Array.isArray(initial?.options)
      ? initial.options.map(o => ({
        id: o.id,
        label: o.label || '',
        employee_id: o.employee_id ? String(o.employee_id) : '',
        team_id: o.team_id ? String(o.team_id) : '',          // <— НОВОЕ
        _deleted: false,
        _mode: o.employee_id ? 'employee' : 'text',
        _empQuery: '', _empResults: [], _empLoading: false
      }))
      : []
  );

  const setOption = (idx, patch) => setOptions(prev => prev.map((o, i) => (i === idx ? { ...o, ...patch } : o)));
  const toggleDelete = (idx) => {
    setOptions((prev) => prev.map((o, i) => (i === idx ? { ...o, _deleted: !o._deleted } : o)));
  };
  const [modeMenuFor, setModeMenuFor] = useState(null);
  const [draggingOptionIndex, setDraggingOptionIndex] = useState(null);
  const [dragOverOptionIndex, setDragOverOptionIndex] = useState(null);
  function addEmptyOption() {
    setOptions(prev => [...prev, {
      id: undefined,
      label: '',
      employee_id: '',
      _deleted: false,
      _mode: 'text', _empQuery: '', _empResults: [], _empLoading: false
    }]);
  }
  const moveOption = (fromIdx, toIdx) => {
    if (fromIdx === toIdx) return;
    setOptions((prev) => {
      if (fromIdx < 0 || toIdx < 0 || fromIdx >= prev.length || toIdx >= prev.length) return prev;
      const next = [...prev];
      const [moved] = next.splice(fromIdx, 1);
      next.splice(toIdx, 0, moved);
      return next;
    });
  };

  useEffect(() => {
    if (draggingOptionIndex !== null) {
      document.body.classList.add('pollDraggingCursor');
      return () => document.body.classList.remove('pollDraggingCursor');
    }
    document.body.classList.remove('pollDraggingCursor');
    return undefined;
  }, [draggingOptionIndex]);

  useEffect(() => {
    if (draggingOptionIndex === null) return undefined;
    const moveByPointer = (evt) => {
      const el = document.elementFromPoint(evt.clientX, evt.clientY);
      const row = el?.closest?.('[data-poll-option-index]');
      if (!row) return;
      const targetIdx = Number(row.getAttribute('data-poll-option-index'));
      if (!Number.isInteger(targetIdx)) return;
      if (targetIdx === draggingOptionIndex) return;
      moveOption(draggingOptionIndex, targetIdx);
      setDraggingOptionIndex(targetIdx);
      setDragOverOptionIndex(targetIdx);
    };
    const stopPointerDrag = () => {
      setDraggingOptionIndex(null);
      setDragOverOptionIndex(null);
    };
    window.addEventListener('pointermove', moveByPointer, { passive: true });
    window.addEventListener('pointerup', stopPointerDrag);
    window.addEventListener('pointercancel', stopPointerDrag);
    return () => {
      window.removeEventListener('pointermove', moveByPointer);
      window.removeEventListener('pointerup', stopPointerDrag);
      window.removeEventListener('pointercancel', stopPointerDrag);
    };
  }, [draggingOptionIndex]);
  // Загрузчики всех сотрудников/команд (для авто-подстановки при сохранении)
  async function fetchAllEmployees() {
    const res = await apiFetch(`${API_URL}/admin/polls/employees/all`);
    const list = res.ok ? await res.json() : [];
    return list.map(e => ({
      id: undefined,
      label: e.name || '',
      employee_id: String(e.id),
      _deleted: false,
      _mode: 'employee',
      _empQuery: '', _empResults: [], _empLoading: false,
    }));
  }
  async function fetchAllTeams() {
    const res = await apiFetch(`${API_URL}/structure/teams`);
    const list = res.ok ? await res.json() : [];
    return list.map(t => ({
      id: undefined,
      label: t.name || '',
      employee_id: '',
      team_id: String(t.id),
      _deleted: false,
      _mode: 'text',
      _empQuery: '', _empResults: [], _empLoading: false,
    }));
  }

  // --- работа с картинкой ---
  const applyImageFile = (f) => {
    if (!f) return;
    if (imagePreview) {
      URL.revokeObjectURL(imagePreview);
    }
    setImageFile(f);
    setKeepInitial(false);                    // прячем старую, показываем новую
    setImagePreview(URL.createObjectURL(f));
  };
  const handlePickImage = (e) => {
    const f = e.target.files?.[0];
    applyImageFile(f);
  };
  const handleDragOverImage = (e) => {
    e.preventDefault();
    if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
    setIsDragOverImage(true);
  };
  const handleDragLeaveImage = (e) => {
    e.preventDefault();
    setIsDragOverImage(false);
  };
  const handleDropImage = (e) => {
    e.preventDefault();
    setIsDragOverImage(false);
    const f = e.dataTransfer?.files?.[0];
    if (!f || !String(f.type || '').startsWith('image/')) return;
    applyImageFile(f);
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview(null);
    setKeepInitial(false);                    // пользователь удалил старую картинку
    if (fileRef.current) fileRef.current.value = '';
  };

  const [saving, setSaving] = useState(false);
  const canSave = titleVal.trim().length > 0 && !saving;
  const [isMobileOptionsUi, setIsMobileOptionsUi] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(max-width: 767px)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mq = window.matchMedia('(max-width: 767px)');
    const sync = () => setIsMobileOptionsUi(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  const submit = async () => {
    if (saving) return;
    setSaving(true);
    try {
      const base = {
        title: titleVal.trim(),
        description: (desc || '').trim() || null,
        is_multiple: !!allowMultiple,
        start_at: startsAt || null,
        end_at: endsAt || null,
      };

      // 1) Если выбран новый файл — загружаем его на бэкенд и получаем image_path
      let uploadedImagePath = undefined;
      if (imageFile) {
        const fd = new FormData();
        fd.append('file', imageFile);
        const up = await apiFetch(`${API_URL}/admin/polls/upload`, {
          method: 'POST',
          body: fd, // НЕ ставим Content-Type — браузер проставит boundary сам
        });
        if (!up.ok) { alert('Не удалось загрузить картинку'); return; }
        const upJson = await up.json();
        uploadedImagePath = upJson?.image_path || null; // строка или null
      }

      // 2) Вычисляем финальные options согласно типу
      let finalOptions = options;
      if (pollType === 'employees') {
        finalOptions = await fetchAllEmployees();
      } else if (pollType === 'teams') {
        finalOptions = await fetchAllTeams();
      }

      if (!initial) {
        // создание — добавили team_id
        const opts = finalOptions
          .filter(o => !o._deleted)
          .map(o => ({
            label: (o.label || '').trim() || null,
            employee_id: o.employee_id ? Number(o.employee_id) : null,
            team_id: o.team_id ? Number(o.team_id) : null,
          }))
          .filter(o => o.label !== null || o.employee_id !== null || o.team_id !== null);

        const payload = {
          ...base,
          type: pollType,
          options: opts,
          image_path: uploadedImagePath !== undefined ? uploadedImagePath : null,
        };
        await onSubmit?.(payload);
      } else {
        // PATCH: если тип не 'options', шлём чистый набор без id (сервер пересоздаст опции)
        let payloadOptions;
        if (pollType !== 'options') {
          // редактирование, ветка pollType !== 'options' — тоже передаём team_id
          payloadOptions = finalOptions
            .filter(o => !o._deleted)
            .map(o => ({
              label: (o.label || '').trim() || null,
              employee_id: o.employee_id ? Number(o.employee_id) : null,
              team_id: o.team_id ? Number(o.team_id) : null,
            }));
        } else {
          payloadOptions = options
            .map(o => {
              if (o.id && o._deleted) return { id: o.id, _action: 'delete' };
              if (o.id) {
                return {
                  id: o.id,
                  label: (o.label || '').trim() || null,
                  employee_id: o.employee_id ? Number(o.employee_id) : null,
                  team_id: o.team_id ? Number(o.team_id) : null,
                };
              }
              if (o._deleted) return null;
              return {
                label: (o.label || '').trim() || null,
                employee_id: o.employee_id ? Number(o.employee_id) : null,
                team_id: o.team_id ? Number(o.team_id) : null,
              };
            })
            .filter(Boolean)
            .filter(o => !('id' in o) ? (o.label !== null || o.employee_id !== null) : true);
        }

        const patch = { ...base, type: pollType, options: payloadOptions };

        if (uploadedImagePath !== undefined) {
          patch.image_path = uploadedImagePath;
        } else if (initial?.image_path && !keepInitial) {
          patch.image_path = null;
        }

        await onSubmit?.(patch);
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={s.modalBackdrop} role="dialog" aria-modal="true" onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className={s.modalCard} onClick={(e) => e.stopPropagation()}>
        <div className={s.modalHeader}>
          <strong>{title}</strong>
          <button className={s.modalClose} onClick={onCancel} aria-label="Закрыть">
            <CloseIcon />
          </button>
        </div>

        <div className={s.createForm}>
          {/* Верхняя строка: тип голосования + тип выбора */}
          <div className={s.createGridRow} style={{ gap: 8, marginBottom: 6 }}>
            <div>
              <label className={s.label}>Тип голосования</label>
              <Select
                className={s.fieldInput}
                value={pollType}
                onChange={(e) => setPollType(e.target.value)}
                ariaLabel="Тип голосования"
              >
                <option value="options">Варианты</option>
                <option value="employees">Сотрудники</option>
                <option value="teams">Команды</option>
              </Select>
            </div>
            <div>
              <label className={s.label}>Тип выбора</label>
              <Select
                className={s.fieldInput}
                value={allowMultiple ? 'multiple' : 'single'}
                onChange={(e) => setAllowMultiple(e.target.value === 'multiple')}
                ariaLabel="Тип выбора"
              >
                <option value="single">Один вариант</option>
                <option value="multiple">Несколько вариантов</option>
              </Select>
            </div>
          </div>
          {pollType !== 'options' && (
            <div className={s.pollInfoNotice}>
              {pollType === 'employees'
                ? 'При сохранении варианты будут автоматически заполнены всеми сотрудниками (кроме «System bot»).'
                : 'При сохранении варианты будут автоматически заполнены всеми командами.'}
            </div>
          )}

          <div>
            <label className={s.label}>Название <span style={{ color: '#C01048', fontWeight: "400" }}>*</span></label>
            <Input className={s.fieldInput} value={titleVal} onChange={e => setTitleVal(e.target.value)} ariaLabel="Название голосования" />
          </div>

          <div>
            <label className={s.label}>Текст голосования</label>
            <Textarea
              className={s.birthdayText}
              rows={4}
              value={desc}
              onChange={e => setDesc(e.target.value)}
              ariaLabel="Текст голосования"
            />
          </div>

          {/* Ручной ввод вариантов показываем только в режиме 'options' */}
          {pollType === 'options' && (
            <div>
              <label className={s.label} style={{ marginTop: 8 }}>Варианты <span style={{ color: '#C01048' }}>*</span></label>
              <ul className={`${s.list} ${draggingOptionIndex !== null ? s.pollOptionsDragging : ''}`}>
                {options.map((o, i) => {
                  const isDragTarget =
                    dragOverOptionIndex === i &&
                    draggingOptionIndex !== null &&
                    draggingOptionIndex !== i;
                  const isDraggingRow = draggingOptionIndex === i;
                  return (
                    <li
                      key={i}
                      data-poll-option-index={i}
                      className={`${s.row} ${s.pollOptionRow} ${isDragTarget ? s.pollOptionRowDropTarget : ''} ${isDraggingRow ? s.pollOptionRowDragging : ''}`}
                      style={o._deleted ? { opacity: 0.55 } : undefined}
                    >
                      <div className={s.main}>
                        <div className={s.rowInline} style={{ gap: 6 }}>
                          <button
                            type="button"
                            className={s.pollOptionDragHandle}
                            title="Переместить вариант"
                            aria-label="Переместить вариант"
                            onPointerDown={(e) => {
                              if (o._deleted) {
                                return;
                              }
                              e.preventDefault();
                              setDraggingOptionIndex(i);
                              setDragOverOptionIndex(i);
                              setModeMenuFor(null);
                            }}
                          >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                              <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                          <div style={{ position: 'relative', flex: 1 }}>
                            {!o._deleted && (
                              <>
                                <button
                                  type="button"
                                  className={s.iconBtn}
                                  onClick={() => setModeMenuFor(modeMenuFor === i ? null : i)}
                                  aria-label="Выбрать режим варианта"
                                  style={{
                                    position: 'absolute',
                                    left: 6,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 3,
                                    fontSize: 12,
                                    padding: '3px 6px',
                                    width: isMobileOptionsUi ? 40 : 88,
                                    borderRadius: 6,
                                    border: '1px solid #e5e7eb',
                                    background: '#fff',
                                    color: '#111',
                                    textAlign: 'left'
                                  }}
                                >
                                  <span className={s.optionModeLabelDesktop}>
                                    {o._mode === 'employee' ? 'Сотрудник ▾' : 'Вариант ▾'}
                                  </span>
                                  <span className={s.optionModeLabelMobile} aria-hidden="true">
                                    {o._mode === 'employee' ? (
                                      <>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                        ▾
                                      </>
                                    ) : (
                                      <>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M7 14.5H17M6 10H6.01M10 10H10.01M14 10H14.01M18 10H18.01M5.2 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H5.2C4.07989 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.07989 2 9.2V14.8C2 15.9201 2 16.4802 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.51984 18 4.0799 18 5.2 18Z"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                        ▾
                                      </>
                                    )}
                                  </span>
                                </button>
                                {modeMenuFor === i && (
                                  <div
                                    onMouseDown={(e) => e.preventDefault()}
                                    style={{
                                      position: 'absolute',
                                      left: 6,
                                      top: 'calc(50% + 16px)',
                                      zIndex: 10,
                                      minWidth: 120,
                                      border: '1px solid #eee',
                                      borderRadius: 8,
                                      background: '#fff',
                                      boxShadow: '0 8px 24px rgba(0,0,0,.08)',
                                      overflow: 'hidden'
                                    }}
                                  >
                                    <button
                                      type="button"
                                      onMouseDown={(e) => {
                                        e.preventDefault();
                                        setOption(i, { _mode: 'text', _empQuery: '', _empResults: [], employee_id: '' });
                                        setModeMenuFor(null);
                                      }}
                                      style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', border: 'none', background: '#fff', cursor: 'pointer' }}
                                    >
                                      Вариант
                                    </button>
                                    <button
                                      type="button"
                                      onMouseDown={(e) => {
                                        e.preventDefault();
                                        setOption(i, { _mode: 'employee', _empQuery: o.label || '' });
                                        setModeMenuFor(null);
                                      }}
                                      style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', border: 'none', background: '#fff', cursor: 'pointer' }}
                                    >
                                      Сотрудник
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                            <Input
                              className={s.fieldInput}
                              placeholder={o._mode === 'employee' ? 'Введите имя сотрудника…' : 'Введите вариант ответа'}
                              value={o._mode === 'employee' ? (o.employee_id ? (o.label || '') : (o._empQuery || '')) : (o.label || '')}
                              onChange={(e) => {
                                const v = e.target.value;
                                if (o._mode === 'employee') {
                                  setOption(i, { _empQuery: v, label: v, employee_id: '' });
                                  return;
                                }
                                setOption(i, { label: v, employee_id: '' });
                              }}
                              ariaLabel="Вариант ответа"
                              disabled={o._deleted}
                              style={!o._deleted ? { paddingLeft: isMobileOptionsUi ? 52 : 104 } : undefined}
                            />
                            {o._mode === 'employee' && !!(o._empQuery || '').trim() && !o._deleted && (
                              <EmployeeSearchDropdown
                                query={o._empQuery}
                                onLoading={(val) => setOption(i, { _empLoading: val })}
                                onResults={(list) => setOption(i, { _empResults: list })}
                                results={o._empResults}
                                loading={o._empLoading}
                                onPick={(emp) => {
                                  setOption(i, {
                                    employee_id: String(emp.id),
                                    label: (emp.name || emp.full_name || '').trim(),
                                    _empQuery: '',
                                    _empResults: []
                                  });
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className={s.actions}>
                        <button
                          type="button"
                          className={`${s.iconBtn} ${o._deleted ? s.optionRestoreBtn : s.optionDeleteBtn}`}
                          title={o._deleted ? 'Восстановить вариант' : 'Удалить вариант'}
                          aria-label={o._deleted ? 'Восстановить вариант' : 'Удалить вариант'}
                          onClick={() => toggleDelete(i)}
                        >
                          {o._deleted ? (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M2 10C2 10 4.00498 7.26822 5.63384 5.63824C7.26269 4.00827 9.5136 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.89691 21 4.43511 18.2543 3.35177 14.5M2 10V4M2 10H8"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>

                          ) : (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </button>
                      </div>
                    </li>
                  );
                })}
              </ul>

              <div style={{ marginTop: 10 }}>
                <button
                  type="button"
                  className={s.addOptionBtn}
                  onClick={addEmptyOption}
                  aria-label="Добавить вариант"
                >
                  + Добавить вариант
                </button>
              </div>
            </div>
          )}
        </div>

        <div className={s.modalFooter}>
          <button className={s.btnCancel} onClick={onCancel}>Отмена</button>
          <button className={s.btnPrimary} onClick={submit} disabled={!canSave}>
            {saving ? 'Сохранение…' : 'Сохранить'}
          </button>
        </div>
      </div>
    </div>
  );
}

/** Выпадающий список поиска сотрудников с дебаунсом */
function EmployeeSearchDropdown({ query, onLoading, onResults, results, loading, onPick }) {
  useEffect(() => {
    const q = (query || '').trim();
    if (!q) { onResults([]); return; }
    const t = setTimeout(async () => {
      try {
        onLoading?.(true);
        const r = await apiFetch(`${API_URL}/employees/search/?query=${encodeURIComponent(q)}`);
        const list = r.ok ? await r.json() : [];
        onResults(Array.isArray(list) ? list : []);
      } catch { onResults([]); }
      finally { onLoading?.(false); }
    }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <div
      onMouseDown={(e) => e.preventDefault()}
      style={{
        position: 'absolute', left: 0, right: 0, top: '100%', background: '#fff',
        border: '1px solid #eee', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,.08)', zIndex: 20
      }}>
      {loading && <div style={{ padding: 8, fontSize: 12, color: '#666' }}>Поиск…</div>}
      {!loading && (results || []).slice(0, 10).map(e => (
        <div
          key={e.id}
          onMouseDown={(evt) => { evt.preventDefault(); onPick?.(e); }}
          style={{ padding: 8, cursor: 'pointer' }}
        >
          {(e.name || e.full_name || '').trim()}
        </div>
      ))}
    </div>
  );
}

/** ======================== МОДАЛКА ДЕТАЛЕЙ (РЕЗУЛЬТАТЫ) ======================== */
function PollDetailModal({ data, onClose, onReload }) {
  const poll = data?.poll || {};
  const scores = useMemo(
    () => (Array.isArray(data?.scores) ? data.scores : []),
    [data?.scores]
  );
  const comments = useMemo(
    () => (Array.isArray(data?.comments) ? data.comments : []),
    [data?.comments]
  );


  // вкладки: 'summary' — итоги, 'ballots' — голоса/комментарии
  const [tab, setTab] = useState('ballots');

  // Скопировать «Имя => (вариант)» + «Комментарий: ...» для выбранного варианта
  const copyCommentsForOption = (optionId) => {
    const voters = (ballotsByOption.get(optionId) || []);

    // Подпись выбранного варианта (учитываем текст, сотрудника и команду)
    const opt = (poll.options || []).find(o => o.id === optionId);
    const target =
      (opt?.label && String(opt.label).trim()) ||
      (opt?.employee_id ? `Сотр. #${opt.employee_id}` :
        (opt?.team_id ? `Команда #${opt.team_id}` : `Вариант #${optionId}`));

    const text = voters.map(v => {
      const name = (v.voterName || '').trim();
      const cmt = (v.comment || '').trim();
      return `${name} => (${target})\nКомментарий: ${cmt || '—'}`;
    }).join('\n\n');

    if (!text) return;
    navigator.clipboard?.writeText(text).catch(() => {
      const ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch { }
      document.body.removeChild(ta);
    });
  };

  // Скопировать ВСЕ голоса по всем вариантам в единую простыню
  const copyAllBallots = () => {
    const parts = [];
    (poll.options || []).forEach(opt => {
      const voters = ballotsByOption.get(opt.id) || [];
      if (!voters.length) return;
      // подпись цели (варианта/сотрудника/команды)
      const target =
        (opt?.label && String(opt.label).trim()) ||
        (opt?.employee_id ? `Сотр. #${opt.employee_id}` :
          (opt?.team_id ? `Команда #${opt.team_id}` : `Вариант #${opt.id}`));
      voters.forEach(v => {
        const name = (v.voterName || '').trim();
        const cmt = (v.comment || '').trim();
        parts.push(`${name} => (${target})\nКомментарий: ${cmt || '—'}`);
      });
    });
    const text = parts.join('\n\n');
    if (!text) return;
    navigator.clipboard?.writeText(text).catch(() => {
      const ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch { }
      document.body.removeChild(ta);
    });
  };

  // быстрый доступ к очкам варианта
  const scoreByOption = useMemo(() => {
    const m = new Map();
    scores.forEach(r => m.set(r.option_id, Number(r.score || 0)));
    return m;
  }, [scores]);

  const votedScores = useMemo(() => {
    return scores
      .filter((r) => Number(r?.ballots || 0) > 0 || Number(r?.score || 0) > 0)
      .sort((a, b) => Number(b.score || 0) - Number(a.score || 0));
  }, [scores]);

  const totalScore = useMemo(
    () => votedScores.reduce((sum, r) => sum + Number(r.score || 0), 0),
    [votedScores]
  );

  // группировка голосов/комментариев по варианту — сохраняем employeeId
  const ballotsByOption = useMemo(() => {
    const by = new Map(); // option_id -> [{ voterName, comment, weight, employeeId }]
    (comments || []).forEach(c => {
      const optId = c.option_id ?? c.option?.id;
      if (!optId) return;
      const arr = by.get(optId) || [];
      arr.push({
        voterName:
          c.voter_name || c.employee_name || c.author_name ||
          (c.employee_id ? `Сотр. #${c.employee_id}` : 'Без имени'),
        comment: c.comment || '',
        weight: c.weight != null ? Number(c.weight) : undefined,
        employeeId: c.employee_id ?? c.voter_id ?? null,
      });
      by.set(optId, arr);
    });
    return by;
  }, [comments]);

  // удалить конкретный бюллетень прямо в строке голоса
  const deleteBallotFor = async (empId) => {
    if (!empId) return;
    if (!window.confirm('Удалить этот голос?')) return;
    const r = await apiFetch(`${API_URL}/admin/polls/${poll.id}/ballots/${empId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ option_ids: [] }),
    });
    if (!r.ok) { alert('Не удалось удалить голос'); return; }
    await onReload();
  };

  return (
    <div className={s.modalBackdrop} role="dialog" aria-modal="true" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={s.modalCard} onClick={(e) => e.stopPropagation()}>
        <div className={s.modalHeader}>
          <strong>{poll.title || 'Голосование'}</strong>
          <button className={s.modalClose} onClick={onClose} aria-label="Закрыть"><CloseIcon /></button>
        </div>

        <div className={s.createForm}>
          {poll.description && (
            <>
              <div className={s.label}>Текст голосования</div>
              <div className={s.metaMultiline}>{poll.description}</div>
            </>
          )}

          {/* Переключатель вкладок */}
          <div className={s.rowInline} style={{ gap: 8, margin: '6px 0 8px', alignItems: 'center' }}>
            <button type="button" onClick={() => setTab('summary')} style={pillStyle(tab === 'summary')}>Итоги</button>
            <button type="button" onClick={() => setTab('ballots')} style={pillStyle(tab === 'ballots')}>Голоса</button>
            {/* копировать все голоса — показываем всегда, активность/доступ зависит от наличия бюллетеней */}
            <button
              type="button"
              className={s.iconBtn}
              title="Скопировать все голоса"
              onClick={copyAllBallots}
              aria-label="Скопировать все голоса"
              style={{ marginLeft: 4 }}
              disabled={!((poll.options || []).some(o => (ballotsByOption.get(o.id) || []).length))}
            >
              <CopyMessageIcon style={{ width: 18, height: 18, opacity: ((poll.options || []).some(o => (ballotsByOption.get(o.id) || []).length)) ? 1 : .4 }} />
            </button>
          </div>

          {/* ВКЛАДКА: Итоги */}
          {tab === 'summary' && (
            <>
              <div className={s.label}>Результаты</div>
              {!votedScores.length && <div className={s.meta}>Голосов пока нет</div>}

              {votedScores.map((r) => {
                const opt = (poll.options || []).find((o) => o.id === r.option_id);
                const name = opt?.label || (opt?.employee_id ? `Сотр. #${opt.employee_id}` : `Вариант #${r.option_id}`);
                const points = Number(r.score || 0);
                const percent = totalScore > 0 ? Math.round((points / totalScore) * 100) : 0;
                const voters = ballotsByOption.get(r.option_id) || [];
                const votesCount = Number(r.ballots || voters.length || 0);
                const pointsWord = points === 1 ? 'очко' : (points >= 2 && points <= 4 ? 'очка' : 'очков');
                const votesWord = votesCount === 1 ? 'голос' : (votesCount >= 2 && votesCount <= 4 ? 'голоса' : 'голосов');

                return (
                  <div key={r.option_id} className={s.pollResultCard}>
                    <div className={s.pollResultHead}>
                      <div className={s.pollResultTitle}>{name}</div>
                      <div className={s.pollResultBadge}>{`${points} ${pointsWord} · ${votesCount} ${votesWord}`}</div>
                    </div>

                    <div className={s.pollResultTrack}>
                      <div className={s.pollResultFill} style={{ width: `${percent}%` }} />
                    </div>
                  </div>
                );
              })}
            </>
          )}

          {/* ВКЛАДКА: Голоса/комментарии */}
          {tab === 'ballots' && (
            <>
              {(poll.options || []).map(opt => {
                const voters = ballotsByOption.get(opt.id) || [];
                if (!voters.length) return null;

                const points = scoreByOption.get(opt.id) || 0;
                return (
                  <div key={opt.id} className={s.pollBallotCard}>
                    <div className={s.pollBallotHead}>
                      <div className={s.pollBallotTitle}>
                        {(opt.label || (opt.employee_id ? `Сотр. #${opt.employee_id}` : `Вариант #${opt.id}`))}
                      </div>
                      <div className={s.pollBallotHeadActions}>
                        <div className={s.pollResultBadge}>{`Всего очков: ${points}`}</div>
                        <button
                          type="button"
                          className={s.iconBtn}
                          title="Скопировать авторов и комментарии"
                          onClick={() => copyCommentsForOption(opt.id)}
                          aria-label="Скопировать авторов и комментарии"
                        >
                          <CopyMessageIcon style={{ width: 18, height: 18 }} />
                        </button>
                      </div>
                    </div>

                    <ul className={s.pollBallotList}>
                      {voters.map((v, i) => (
                        <li key={i} className={s.pollBallotVoteItem}>
                          <div className={s.pollBallotVoteMain}>
                            <div className={s.pollBallotWho}>
                              {v.voterName}
                              {v.weight != null ? ` (вес: ${v.weight})` : ''}
                            </div>
                            <div className={s.pollBallotComment}>
                              <span className={s.pollBallotLabel}>Комментарий:</span> {v.comment?.trim() ? v.comment : '—'}
                            </div>
                          </div>
                          <div className={s.pollBallotVoteActions}>
                            <button
                              type="button"
                              className={s.iconBtn}
                              title="Удалить этот голос"
                              onClick={() => deleteBallotFor(v.employeeId)}
                              disabled={!v.employeeId}
                            >
                              ✕
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
              {/* если ни у одного варианта нет голосов */}
              {!(poll.options || []).some(o => (ballotsByOption.get(o.id) || []).length) && (
                <div className={s.meta}>Голосов пока нет</div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}


/** ======================== УТИЛЫ ======================== */
function pillStyle(active) {
  return {
    minWidth: 32,
    height: 32,
    padding: '0 10px',
    borderRadius: 16,
    border: `1px solid ${active ? '#BD23DB' : '#E5E7EB'}`,
    background: active ? '#E9C6FE' : '#fff',
    color: '#111',
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',
  };
}

function toLocalDatetime(iso) {
  // переводим ISO → yyyy-MM-ddTHH:mm без секунд/зоны для input[type=datetime-local]
  try {
    const d = new Date(iso);
    const pad = (n) => String(n).padStart(2, '0');
    const y = d.getFullYear();
    const m = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const h = pad(d.getHours());
    const mm = pad(d.getMinutes());
    return `${y}-${m}-${day}T${h}:${mm}`;
  } catch { return ''; }
}
